<template>
  <div class="modal fade show d-block" tabindex="-1" @click.self="$emit('close')">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Request Feedback</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>

        <form @submit.prevent="submit">
          <div class="modal-body">
            <!-- User Select (like ManagerSelectionModal) -->
            <div class="mb-3">
              <label for="userSelect" class="form-label">User <span class="text-danger">*</span></label>
              <select
                id="userSelect"
                v-model="selected"
                class="form-select"
                :class="{ 'is-invalid': showValidation && !selected }"
                required
              >
                <option value="">Choose a user...</option>
                <option v-for="u in users" :key="u.id" :value="u.id">
                  {{ u.first_name }} {{ u.last_name }}
                </option>
              </select>
              <div v-if="showValidation && !selected" class="invalid-feedback">
                Please select a user
              </div>
            </div>

            <!-- Relationship -->
            <div class="mb-3">
              <label class="form-label">Relationship<span class="text-danger"> *</span></label>
              <select v-model="relationship" class="form-select" required>
                <option value="">Select relationship</option>
                <option value="peer">Peer</option>
                <option value="subordinate">Subordinate</option>
                <option value="client">Client</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div class="alert alert-info">
              Select one colleague and specify the relationship. They'll receive a request to provide feedback for this review.
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="$emit('close')">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="submitting || !selected || !relationship">
              <span v-if="submitting" class="spinner-border spinner-border-sm me-2"></span>
              Request Feedback
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
import { ref, onMounted } from 'vue'
import userService from '@/api/userService'
import notify from '@/utils/notify'

export default {
  name: 'RequestFeedbackModal',
  props: {
    reviewId: { type: [String, Number], required: true }
  },
  emits: ['close', 'submitted'],
  setup(props, { emit }) {
    const submitting = ref(false)
    const users = ref([])
    const selected = ref('')
    const relationship = ref('')
    const showValidation = ref(false)
    const loadUsers = async () => {
      try {
        users.value = await userService.getUsers() || []
      } catch (e) {
        users.value = []
      }
    }

    const submit = async () => {
      if (!selected.value || !relationship.value) {
        showValidation.value = true
        notify.alert?.error?.('Please select a user and relationship')
        return
      }
      submitting.value = true
      try {
        emit('submitted', { requested_from: selected.value, relationship: relationship.value })
      } finally {
        submitting.value = false
      }
    }

    onMounted(loadUsers)

    return { submitting, users, selected, relationship, showValidation, submit }
  }
}
</script>

<style scoped>
.modal { background-color: rgba(0, 0, 0, 0.1); }
</style>
